import { Typography } from 'antd';
import styled from 'styled-components';

export const IntroStyled = styled(`section`)`
	position: relative;
	display: flex;
	justify-content: center;s
	align-items: center;
	overflow-x: hidden;
	margin-bottom: 40px;
	width: 100vw;
	background-color: #e6f7ff;

	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		height: 345px;
		width: 100%;
		align-items: flex-start;
		margin-bottom: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		height: 345px;
		align-items: flex-start;
		margin-bottom: 40px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		height: 403px;
		align-items: flex-start;
		margin-bottom: 40px;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		height: 403px;
		margin-bottom: 40px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		height: 332px;
		margin-bottom: 40px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		height: 332px;
		margin-bottom: 40px;
	}
`;
export const IntroTextStyled = styled(Typography.Text)`
	font-weight: 600;
	font-size: 38px;
	line-height: 36px;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		font-size: 24px;
		font-weight: 400;
		line-height: 32px;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 30px;
		line-height: 38px;
	}
	@media (min-width: ${props => props.theme.breakpoints.md}) {
		font-size: 38px;
		line-height: 46px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 38px;
		line-height: 46px;
	}
`;

export const IntroContentStyled = styled(`div`)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-left: 3px;
	width: 1200px;

	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: 100%;
		margin: 0 16px;
		flex-direction: column-reverse;
		align-items: top;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
		flex-direction: column-reverse;
		align-items: top;
	}
	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 992px;
		flex-direction: column-reverse;
		align-items: top;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 916px;
		flex-direction: row;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 1200px;
		flex-direction: row;
	}
	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 1200px;
		flex-direction: row;
	}
`;

export const IntroImageStyled = styled(`img`)`
	height: 333px;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		display: none;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		display: block;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		display: block;
	}
`;

export const IntroImageTStyled = styled(`img`)`
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		display: none;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		display: block;
		height: 403px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		display: none;
	}
`;

export const IntroImageMStyled = styled(`img`)`
	position: absolute;
	top: 0;
	overflow-x: hidden;
	height: 130px;

	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		display: block;
		height: 90px;
		margin-bottom: 32px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		display: block;
		height: 97px;
		margin-bottom: 40px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		display: block;
		width: 992px;
		margin-bottom: 40px;
		height: 130px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		display: none;
	}
`;

export const IntroTextContainerStyled = styled(`div`)`
	gap: 24px;
	display: flex;
	flex-direction: column;
	max-width: 650px;

	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		gap: 20px;
		margin-top: 122px;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		gap: 20px;
		margin-top: 137px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		margin-top: 170px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		max-width: 440px;
		margin-top: 0;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		max-width: 648px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		max-width: 648px;
	}
`;

export const IntroDescriptionStyled = styled(`p`)`
	color: #262626;
	font-weight: 400;
	font-size: 20px;
	line-height: 28px;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		font-size: 14px;
		line-height: 24px;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 16px;
		line-height: 24px;
	}
`;
